import { type Delta, type Op } from 'quill/core';

export class ServerDelta implements Delta {
  /* a server-side partial implementation of the Quill Delta */
  ops: Op[] = [];

  static notImplemented = () => {
    throw new Error('Not implemented');
  };

  insert = ServerDelta.notImplemented;
  delete = ServerDelta.notImplemented;
  retain = ServerDelta.notImplemented;
  chop = ServerDelta.notImplemented;
  filter = ServerDelta.notImplemented;
  forEach = ServerDelta.notImplemented;
  map = ServerDelta.notImplemented;
  partition = ServerDelta.notImplemented;
  reduce = ServerDelta.notImplemented;
  changeLength = ServerDelta.notImplemented;
  length = ServerDelta.notImplemented;
  slice = ServerDelta.notImplemented;
  compose = ServerDelta.notImplemented;
  concat = ServerDelta.notImplemented;
  diff = ServerDelta.notImplemented;
  eachLine = ServerDelta.notImplemented;
  invert = ServerDelta.notImplemented;
  transform = ServerDelta.notImplemented;
  transformPosition = ServerDelta.notImplemented;

  push(op: Op) {
    this.ops.push(op);
    return this;
  }
}
